module.exports = __webpack_public_path__ + "static/img/glove_noir.26721e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_noir.png
// module id = Vwnt
// module chunks = 0